/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_AccessibilityInputs */

const he_footer_accessibility = /** @type {(inputs: Footer_AccessibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הצהרת נגישות`)
};

const en_footer_accessibility = /** @type {(inputs: Footer_AccessibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessibility Statement`)
};

/**
* | output |
* | --- |
* | "Accessibility Statement" |
*
* @param {Footer_AccessibilityInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_accessibility = /** @type {((inputs?: Footer_AccessibilityInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_AccessibilityInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_footer_accessibility(inputs)
	return en_footer_accessibility(inputs)
});